import { render } from "./DemoView.vue?vue&type=template&id=4e597fcf&scoped=true"
const script = {}

import "./DemoView.vue?vue&type=style&index=0&id=4e597fcf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e597fcf"]])

export default __exports__